import React from 'react'

import InvalidForm from 'src/components/InvalidForm'

// The donate button is our element styled to match the widget, but Blackbaud
// owns its click: completeCheckoutButtonComponent wires it straight to their
// authorization flow. It stays enabled except while a donation is processing
// (so a stray double-click can't double-submit); form validity is enforced on
// click inside useBlackbaudCheckout, which surfaces errors and blocks the
// authorization when the form isn't ready.
const BlackbaudCheckout = ({ i18n, donation, record, checkout, errors }) =>
  <div className="mb-3">
    <div id={checkout.inlineContainerId} />
    <div id={checkout.buttonContainerId} />
    <div className="d-grid">
      <button
        id={checkout.buttonId}
        type="button"
        className={`btn btn-lg btn-primary${checkout.buttonLocked ? ' disabled' : ''}`}
        aria-disabled={checkout.buttonLocked || undefined}
        tabIndex={checkout.buttonLocked ? -1 : undefined}
        style={checkout.buttonLocked ? { pointerEvents: 'none' } : undefined}
        disabled={record.processing}
      >
        {i18n.t('donate_total_recurrence', {
          total: i18n.formatCurrency(checkout.total, donation.currency),
          recurrence: i18n.t(`subscription_labels.${donation.state.subscription}.submit`),
        })}
      </button>
    </div>
    <InvalidForm>{errors?.base?.[0]}</InvalidForm>
  </div>

export default BlackbaudCheckout
